import dayjs from "dayjs"

export default (ctx, payload) => {
	const workSheetData = [header, ...rows(payload)]
	const workSheetColumns = header.map(item => {
		return { wpx: 200 }
	})
	return { workSheetData, workSheetColumns }
}

const header = [
	"Policy Number",
	"Client",
	"Title",
	"Content",
	"Created By",
  "Created At",
  "Last Modified By",
  "Last Modified At",
]

const rows = payload => {
	const output = []
	payload.map(quote => {
		output.push(
			...quote.notes.map(note => {
				return [
					quote.issuerNumber,
					quote.contractHolder.name,
					note.title,
					note.content,
					note?.createdBy?.username,
					dayjs(note.createdAt).format("DD/MM/YYYY HH:mm:ss"),
					note?.lastModifiedBy?.username,
					dayjs(note.lastModifiedAt).format("DD/MM/YYYY HH:mm:ss")
				]
			})
		)
	})
	return output
}
